import { LITE_TRADE_NOTIFICATION_STATUSES, LITE_TRADE_NOTIFICATION_TYPES } from "./liteTradeNotificationConstants";

export const getLiteTradeNotificationStatusByNotificationType = (notificationType) => {
    switch (notificationType) {
        case LITE_TRADE_NOTIFICATION_TYPES.ORDER_CANCELED:
        case LITE_TRADE_NOTIFICATION_TYPES.ORDER_REJECTED:
            return LITE_TRADE_NOTIFICATION_STATUSES.WARNING
        case LITE_TRADE_NOTIFICATION_TYPES.MARGIN_CALL:
        case LITE_TRADE_NOTIFICATION_TYPES.LIQUIDATION:
            return LITE_TRADE_NOTIFICATION_STATUSES.ATTENTION;
        default:
            return LITE_TRADE_NOTIFICATION_STATUSES.SUCCESS;
    }
}
